<template>
  <header class="fixed top-0 left-0 w-full z-50 backdrop-blur-md
         after:absolute after:bottom-0 after:left-0 after:w-full after:h-[1px] 
         after:bg-[linear-gradient(90deg,rgba(42,42,64,0)_0%,#2A2A40_49.9%,rgba(42,42,64,0)_100%)]">
    <div class="max-w-screen-xl mx-auto px-4 py-5">
      <nav class="flex items-center justify-between">
        <!-- Logo Section -->
        <div class="flex items-center cursor-pointer" @click="navigateTo('/')">
          <NuxtImg src="/logos/nuxtstore-logo.svg" alt="Nuxt Store Logo" width="33" height="33" class="mr-2" loading="lazy" />
          <h1 class="text-[24px] text-[var(--text-primary)] leading-none font-poppins">
            <span class="font-normal">Nuxt.</span>
            <span class="font-bold">store</span>
          </h1>
        </div>

        <!-- Desktop Navigation -->
        <div class="hidden lg:flex items-center space-x-8 border border-[var(--border-primary)] rounded-3xl px-14 py-4">
          <NuxtLink to="/" active-class="text-[var(--text-tertiary)]"
            class="text-[var(--text-secondary)] font-onest leading-none text-3.5 font-semibold transition-colors">
            Home
          </NuxtLink>
          <NuxtLink to="/features" active-class="text-[var(--text-tertiary)]"
            class="text-[var(--text-secondary)] font-onest leading-none text-3.5 font-semibold transition-colors">
            Features
          </NuxtLink>
          <NuxtLink to="" active-class="text-[var(--text-tertiary)]"
            class="text-[var(--text-secondary)] font-onest leading-none text-3.5 font-semibold transition-colors">
            Documentation
          </NuxtLink>
          <NuxtLink to="" active-class="text-[var(--text-tertiary)]"
            class="text-[var(--text-secondary)] font-onest leading-none text-3.5 font-semibold transition-colors">
            Support
          </NuxtLink>
        </div>

       <!-- Desktop Social Icons -->
<div class="hidden lg:flex items-center space-x-7">
  <a
    aria-label="GitHub"
    href="https://github.com/"
    target="_blank"
    rel="noopener noreferrer"
  >
    <span class="sr-only">GitHub</span>
    <!-- <NsGithub class="fill-[var(--text-primary)] transition-colors" /> -->
    <NsLogo name="NsGithub" class="w-6 h-6 fill-[var(--text-primary)] transition-colors" />
  </a>

  <a
    aria-label="Patreon"
    href="https://www.patreon.com/"
    target="_blank"
    rel="noopener noreferrer"
  >
    <span class="sr-only">Patreon</span>
    <!-- <NsPatreon class="fill-[var(--text-primary)] transition-colors" /> -->
    <NsLogo name="NsPatreon" class="w-6 h-6 fill-[var(--text-primary)] transition-colors" />
  </a>

  <a
    aria-label="Trello"
    href="https://trello.com/"
    target="_blank"
    rel="noopener noreferrer"
  >
    <span class="sr-only">Trello</span>
    <!-- <NsTrello class="fill-[var(--text-primary)] transition-colors" /> -->
    <NsLogo name="NsTrello" class="w-6 h-6 fill-[var(--text-primary)] transition-colors" />
  </a>

  <a
    aria-label="Slack"
    href="https://slack.com/"
    target="_blank"
    rel="noopener noreferrer"
  >
    <span class="sr-only">Slack</span>
    <!-- <NsSlack class="fill-[var(--text-primary)] transition-colors" /> -->
    <NsLogo name="NsSlack" class="w-6 h-6 fill-[var(--text-primary)] transition-colors" />
  </a>
</div>

        <!-- Mobile Menu Toggle -->
          <Button unstyled class="lg:hidden !text-white"
          @click="toggleMobileMenu" aria-label="Toggle mobile menu"> 
          <NsHamburgerIcon class="w-6 h-6" />
        </Button>
      </nav>
    </div>

    <!-- Mobile Sidebar Menu -->
    <Drawer v-model:visible="mobileMenuVisible" position="right"
      class="!w-80 !bg-[var(--background-primary)]  border !border-slate-700" :pt="{
        button: { class: '!text-blue' },
      }">
      <template #header>
        <div class="flex items-center">
          <NuxtImg src="/logos/nuxtstore-logo.svg" alt="Nuxt Store Logo" width="33" height="33" class="mr-2" loading="lazy" />
          <h1 class="text-[24px] text-[var(--text-primary)] leading-none font-poppins">
            <span class="font-normal">Nuxt.</span>
            <span class="font-bold">store</span>
          </h1>
        </div>
      </template>

      <!-- Mobile Navigation Links -->
      <div class="flex flex-col space-y-2 mt-4">
        <NuxtLink to="/" active-class="text-[var(--text-tertiary)]"
          class="text-[var(--text-secondary)] font-onest text-sm font-semibold leading-none px-2 py-2 hover:text-[var(--primary-hover)] transition-colors"
          @click="closeMobileMenu">
          Home
        </NuxtLink>
        <NuxtLink to="/features" active-class="text-[var(--text-tertiary)]"
          class="text-[var(--text-secondary)] font-onest text-sm font-semibold leading-none px-2 py-2 hover:text-[var(--primary-hover)] transition-colors"
          @click="closeMobileMenu">
          Features
        </NuxtLink>
        <NuxtLink to="" active-class="text-[var(--text-tertiary)]"
          class="text-[var(--text-secondary)] font-onest text-sm font-semibold leading-none px-2 py-2 hover:text-[var(--primary-hover)] transition-colors"
          @click="closeMobileMenu">
          Documentation
        </NuxtLink>
        <NuxtLink to="" active-class="text-[var(--text-tertiary)]"
          class="text-[var(--text-secondary)] font-onest text-sm font-semibold leading-none px-2 py-2 hover:text-[var(--primary-hover)] transition-colors"
          @click="closeMobileMenu">
          Support
        </NuxtLink>
      </div>

      <!-- Mobile Social Icons -->
      <div class="flex items-center justify-center space-x-7 mt-8 pt-6 border-t border-slate-700">
        <NuxtLink aria-label="GitHub" to="https://github.com/" @click="closeMobileMenu">
          <!-- <NsGithub class="w-6 h-6 fill-[var(--text-primary)] transition-colors" /> -->
          <NsLogo name="NsGithub" class="w-6 h-6 fill-[var(--text-primary)] transition-colors" />
        </NuxtLink>
        <NuxtLink aria-label="Patreon" to="https://www.patreon.com/" @click="closeMobileMenu">
          <!-- <NsPatreon class="w-6 h-6 fill-[var(--text-primary)] transition-colors" /> -->
          <NsLogo name="NsPatreon" class="w-6 h-6 fill-[var(--text-primary)] transition-colors" />
        </NuxtLink>
        <NuxtLink aria-label="Trello" to="https://trello.com/" @click="closeMobileMenu">
          <!-- <NsTrello class="w-6 h-6 fill-[var(--text-primary)] transition-colors" /> -->
          <NsLogo name="NsTrello" class="w-6 h-6 fill-[var(--text-primary)] transition-colors" />
        </NuxtLink>
        <NuxtLink aria-label="Slack" to="https://slack.com/" @click="closeMobileMenu">
          <!-- <NsSlack class="w-6 h-6 fill-[var(--text-primary)] transition-colors" /> -->
          <NsLogo name="NsSlack" class="w-6 h-6 fill-[var(--text-primary)] transition-colors" />
        </NuxtLink>
      </div>

    </Drawer>
  </header>
</template>

<script setup lang="ts">
import NsHamburgerIcon from './atoms/icons/NsHamburgerIcon.vue';

const NsLogo = defineAsyncComponent(() => import('./NsLogo.vue'));

const mobileMenuVisible = ref(false)

const toggleMobileMenu = () => {
  mobileMenuVisible.value = !mobileMenuVisible.value
}

const closeMobileMenu = () => {
  mobileMenuVisible.value = false
}
</script>